import { TDragDropSortable } from "@ryde/shared";

export const getStationIdsFromSortable = <T>(
  sortable: TDragDropSortable<T>,
): T[] => [...sortable.sortable.items];

export interface IDragStationSortableIndexes {
  oldIndex: number;
  newIndex: number;
}

export const getIndexesFromSortable = <T>(
  sourceSortable: TDragDropSortable<T>,
  destinationSortable: TDragDropSortable<T>,
): IDragStationSortableIndexes => {
  const indexes: IDragStationSortableIndexes = {
    oldIndex: sourceSortable.sortable.index,
    newIndex: destinationSortable.sortable.index,
  };
  return indexes;
};
